import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getModuleData } from '../../../selectors/modules';
import { Props } from './Admins';

type StateProps = Pick<Props, 'roles' | 'results'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const { roles, results } = getModuleData(state, ownProps.moduleId);
  return {
    roles,
    results,
  };
};

export default connect(mapStateToProps);
